import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import AsyncSelect from 'react-select/lib/Async';
import ReactModal from "react-modal";
import { isNullOrUndefined } from 'util';
import { AbconetApi } from '../General/AbconetApi';

import ViewSwitcher from "../General/ViewSwitcher";

var ScheduleSelector = require('../General/Selectors/ScheduleSelector').ScheduleSelector;
var SiteSelector = require('../General/Selectors/SiteSelector').SiteSelector;
var GroupSelector = require('../General/Selectors/GroupSelector').GroupSelector;
var ProductSelector = require('../General/Selectors/ProductSelector').ProductSelector;

import Select from 'react-select';
import React from 'react';

export class TemplateEditLine extends React.Component {

    removeItem(ev) {
        ev.preventDefault();
        this.props.removeItemClick();
        this.props.onChange();
    }

    updateQuantity(ev) {
        this.props.updateQuantityChange(ev);
    }



    render() {
        var product = this.props.templateLine.product;
        var size = product.imageFileName == 'no-image.svg' ? '40' : '';
        var checkboxId = "rechargeable" + product.stockcode;

        var disabled = false;
        var renderTextbox = <Text field="quantity" type="number" value="quantity" className="form-control add-item" onChange={this.updateQuantity.bind(this)} />;
        if (this.props.limitOrderToApprovedStocklist && product.isApprovedStocklist == false) {
            disabled = true;
            renderTextbox = <Text type="number" value="0" defaultValue="0" className="form-control add-item" disabled={disabled} />
        } 
        if (this.props.isCompactView) {
            return (
                <div className="item" key={product.stockcode}>
                    <div className="row">
                        <div className="col-2 col-lg-1">
                            <span className="stockcode">{product.stockcode}</span>
                        </div>
                        <div className="col-5 col-lg-8">
                            <p className="description">{product.name}</p>
                        </div>
                        <div className="col-3 col-lg-1">
                            <span className="price">${product.bestPrice.toFixed(2)}</span>
                        </div>
                        <div className="col-2 col-lg-1 input-qty-container">
                            {renderTextbox}
                        </div>
                        <div className="col-12 col-lg-1 actions-container rechargeable-column">
                            <div className="custom-control custom-checkbox my-1 mr-sm-2 d-inline">
                                <Checkbox field="rechargeable" id={checkboxId} className="custom-control-input" disabled={disabled} />
                                <label className="custom-control-label" htmlFor={checkboxId}><span className="d-lg-none">Rechargable</span></label>
                            </div>
                            <span >
                                <a href="#" onClick={this.removeItem.bind(this)}><i className="icon icon-close lead"></i></a>
                            </span>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="item" key={product.stockcode}>
                    <div className="row">
                        <div className="col-2 col-lg-1">
                            <a href={product.url}><img src={product.imageFileName} className="product-image" width={size} /></a>
                        </div>
                        <div className="col-5 col-lg-6">
                            <p className="description">{product.name}</p>
                            <span className="stockcode">Code: {product.stockcode}</span>
                        </div>
                        <div className="col-3 col-lg-2">
                            <span className="price">${product.bestPrice.toFixed(2)}</span>
                        </div>
                        <div className="col-2 col-lg-1 input-qty-container">
                            {renderTextbox}
                        </div>
                        <div className="col-12 col-lg-2 actions-container rechargeable-column">
                            <div className="custom-control custom-checkbox my-1 mr-sm-2 d-inline">
                                <Checkbox field="rechargeable" id={checkboxId} className="custom-control-input" disabled={disabled} />
                                <label className="custom-control-label" htmlFor={checkboxId}><span className="d-lg-none">Rechargable</span></label>
                            </div>
                            <span >
                                <a href="#" onClick={this.removeItem.bind(this)}><i className="icon icon-close lead"></i></a>
                            </span>
                        </div>
                    </div>
                </div>
            );
        }
    }
}


export class TemplateEdit extends React.Component {

    constructor(props) {
        super(props);
        this.cronText = React.createRef();
        this.state = {
            isSaved: true,
            scheduleModalOpen: false,
            permissionsModalOpen: false,
            isSaving: false,
            isGroupSaved: true,
            isGroupSaving: false,
            isCompactView: false,
            permissions: {},
            permissionsLoaded: false,
            sortBy: 'stockcodeAsc',
            submittedValues: this.props.initialTemplate
        }
    }

    componentDidMount() {
        this.loadGroupPermssions();
    }

    renderCopyTemplateButton() {
        if (this.props.initialTemplate.id === 0) {
            return null;
        }

        return <button className={"btn btn-primary float-right mr-2 "} onClick={this.openCopyTemplateModal.bind(this)} disabled={this.state.isSaving || !this.state.isSaved}>Copy Template</button>;

    }

    openCopyTemplateModal(ev) {
        ev.preventDefault();
        this.setState({
            copyTemplateModalOpen: true
        });
    }

    closeCopyTemplateModal() {
        this.setState({
            copyTemplateModalOpen: false
        });
    }

    setCopyTemplateChange() {
        this.setState({ isCopyTemplateSaved: false });
    }

    submitCopyTemplate(copyTemplateValues) {

        if (isNullOrUndefined(copyTemplateValues.templateName)) {
            alert('Please enter template name');
            return;
        }

        this.setState({ copyTemplateValues, isCopyTemplateSaving: true }, this.saveCopyTemplate);
    }

    saveCopyTemplate() {
        AbconetApi.post(`/api/template/${this.props.initialTemplate.id}/copy`, this.state.copyTemplateValues).then(template => {
            if (template.id == undefined) {
                console.error("Error creating template", template);
            } else {
                window.location = `/templates/${template.id}/`;
            }

            self.setState({ isSaved: true, submittedValues: template, isSaving: false });

        }).catch((error) => {
            self.setState({
                isSaved: true,
                isSaving: false
            });
        });
    }

    renderSubmitCopyTemplateButton() {
        var btnText = 'Copy Template';
        var btnClass = 'changes';
        if (this.state.isCopyTemplateSaved) {
            btnText = 'Template Copied';
            btnClass = 'saved';
        }

        if (this.state.isCopyTemplateSaving) {
            btnText = 'Copying Template';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isCopyTemplateSaved || this.state.isCopyTemplateSaving}>{btnText}</button>;
    }

    setChange() {
        this.setState({ isSaved: false });
    }
    setGroupChange() {
        this.setState({ isGroupSaved: false });
    }

    addNewLineKeyPress(formApi, ev) {
        if (ev.keyCode === 13 && (formApi.values.productSearch != '' && formApi.values.productSearch != undefined)) {
            ev.preventDefault(); 
            this.addNewLine(formApi);
        }
    }

    validateLength(e, length) {
        if (e.target.value.length > length) {
            e.target.value = e.target.value.slice(0, length)
        } else {
            e.target.value;
        }
    }

    addNewLine(formApi) {
        if (isNullOrUndefined(formApi.values.productSearch) || formApi.values.productSearch == "") {
            alert('Please select a product...');

            return;
        }

        var lineCollection = this.formApi.getValue("lines");

        var index = -1;
        if (!isNullOrUndefined(lineCollection)) {
            index = lineCollection.findIndex(function (obj) {
                return obj.product['stockcode'] === formApi.values.productSearch.stockcode;
            });
        }

        if (index <= -1) {
            formApi.addValue('lines',
                {
                    product: formApi.values.productSearch,
                    quantity: 0,
                    rechargeable: false
                });


            formApi.setValue('productSearch', '');
        } else {
            alert('Product already exists on list.');
        }
    }

    openScheduleModal() {
        this.setState({
            scheduleModalOpen: true
        });
    }

    closeScheduleModal() {
        this.setState({
            scheduleModalOpen: false
        });
    }

    openPermissionsModal(ev) {
        ev.preventDefault();
        this.setState({
            permissionsModalOpen: true
        });
    }

    closePermissionsModal() {
        this.setState({
            permissionsModalOpen: false
        });
    }


    submitTemplate(submittedValues) {
        if (isNullOrUndefined(submittedValues.name) || submittedValues.name == '') {
            alert('Please enter template name');

            return;
        }

        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);  
    }

    submitGroupPermissions(permissions) {
        this.setState({ permissions, isGroupSaving: true }, this.saveGroupPermssion);
    }

    saveGroupPermssion() {
        AbconetApi.post(`/api/template/${this.props.initialTemplate.id}/permissions`, this.state.permissions).then(
            () => {
                setTimeout(
                    () => {
                        this.setState({ isGroupSaved: true, isGroupSaving: false });

                        setTimeout(() => {
                                this.closePermissionsModal();
                            },
                            300);
                    },
                    200);
            });
    }

    loadGroupPermssions() {
        if (this.props.initialTemplate.id === 0) {
            return;
        }

        AbconetApi.get(`/api/template/${this.props.initialTemplate.id}/permissions`, this.state.groupPermissions).then((permissions) => {
            this.setState({ permissions, permissionsLoaded:true });
        });
    }


    sendStateToServer() {
        var self = this;

        AbconetApi.post('/api/template/', this.state.submittedValues).then(template => {
            if (this.props.initialTemplate.id === 0) {
                if (template.id == undefined) {
                    console.error("Error creating template", template);
                } else {
                    window.location = `/templates/${template.id}/`;
                }
            }

            self.setState({ isSaved: true, submittedValues: template, isSaving: false }); 
        }).catch((error) => {
            self.setState({
                isSaved: true,
                isSaving: false
            });
        });
    }

    updateQuantity(line, ev) {
        var lineCollection = this.formApi.getValue("lines");

        var index = lineCollection.findIndex(function (obj) {
            return obj.product['stockcode'] === line.product.stockcode;
        });

        if (ev <= -1) {
            lineCollection[index].quantity = 0;
        } else {
            lineCollection[index].quantity = ev;
        }

        this.formApi.setValue("lines", lineCollection);
    }

    removeLine(line) {
        var lineCollection = this.formApi.getValue("lines");

        var index = lineCollection.findIndex(function (obj) {
            return obj.product['stockcode'] === line.product.stockcode;
        });
        
        lineCollection.splice(index, 1);

        this.formApi.setValue("lines", lineCollection);
    }

    finishEdit() { 
        //if (!this.state.isSaved) {
        //    if (!confirm("Changes you made will not be saved.")) {
        //        return;
        //    }
        //}

        if (this.props.onFinishEdit) {
            this.props.onFinishEdit(this.state.submittedValues);
        }
    }

    createSchedule() {
        //var seqno = this.props.initialTemplate.seqno;
        //var self = this;
        //fetch('/api/template/' + seqno + '/schedule', {
        //    method: 'POST',
        //    body: {
        //        expression: this.cronText
        //    },
        //    headers: {
        //        'Accept': 'application/json',
        //        'Content-Type': 'application/json'
        //    }
        //}).then(function (response) {
        //    return response.json();
        //}).then(function (response) {
        //    self.closeScheduleModal();
        //});


    }

    handleSortChange(selectedOption) { 
        this.setState({ sortBy: selectedOption.value });
    }

    setViewSwitcher(data) { 
        this.setState({ isCompactView: data.isCompactView });
    }

    renderTableHeader(lines, isCompactView) {
        if (lines == null || lines.length === 0) {
            return;
        }
        const { sortBy } = this.state.sortBy;
        var options = [
            { value: 'productcodeAsc', label: 'Stockcode code - Ascending' },
            { value: 'productcodeDesc', label: 'Stockcode code - Descending' },
            { value: 'priceAsc', label: 'Price - Ascending' },
            { value: 'priceDesc', label: 'Price - Descending' },
            { value: 'nameAsc', label: 'Name - Ascending' },
            { value: 'nameDesc', label: 'Name - Descending' },
        ];

        var sort = <div>
            <Select
                className="sort-by-dropdown"
                value={sortBy}
                onChange={this.handleSortChange.bind(this)}
                options={options}
                placeholder="Sort by..."
            />
        </div>;
        
        var switcher =
            <div className="col-12">
                <div className="row">
                    <div className="offset-md-9">
                        <ViewSwitcher onChange={this.setViewSwitcher.bind(this)} />
                    </div>
                    <div className="">
                        {sort}
                    </div>

                </div>
            </div>;       


        if (isCompactView) {
            return <div className="row header">
                {switcher}
                <div className="col-7 col-lg-9 col-hd">
                    Item
                       </div>
                <div className="col-3 col-lg-1 col-hd">
                    Price
                       </div>
                <div className="col-1 col-lg-1 col-hd">
                    Qty
                       </div>
                <div className="col-lg-1 col-hd d-none d-lg-block">
                    Rchg
                       </div>
            </div>;
        }

        return <div className="row header">
            {switcher}
            <div className="col-7 col-lg-7 col-hd">
                Item
               </div>
            <div className="col-3 col-lg-2 col-hd">
                Price
               </div>
            <div className="col-1 col-lg-1 col-hd input-qty-container">
                Qty
               </div>
            <div className="col-lg-2 col-hd d-none d-lg-block">
                Rechargable
               </div>
        </div>;
    }


    renderSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }


        if (this.props.initialTemplate.id === 0) {
            btnText = "Create";
        }

        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }      

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    renderGroupSaveButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isGroupSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }

        if (this.state.isGroupSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }


        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isGroupSaved || this.state.isGroupSaving}>{btnText}</button>;
    }

    renderUpperButtons() {
        if (this.formApi.getValue("lines") != null && this.formApi.getValue("lines").length >= 5) {
            return <div>
                {this.renderSaveButton()}
            </div>;
            
        }
    }

    renderShareButton() {
        if (this.props.initialTemplate.id === 0) {
            return null;
        }

        var btnClass = "";
        if (!this.state.permissionsLoaded) {
            btnClass = ' saving';
        }


        return <button className={"btn btn-primary float-right" + btnClass} onClick={this.openPermissionsModal.bind(this)} disabled={!this.state.permissionsLoaded}>Share</button>;
    }

    renderFinishEditingButton() {
        if (this.props.initialTemplate.id === 0) {
            return;
        }

        return <button onClick={this.finishEdit.bind(this)} disabled={!this.state.isSaved} className="btn btn-outline-primary">Finish Editing</button>;
    }

    getSortedLines(formLines) {
        if (!formLines) {
            return [];
        }
        var sortBy = this.state.sortBy;
        switch (sortBy) {
            case 'productcodeAsc':
                formLines.sort((a, b) => {
                    if (a.product.stockcode < b.product.stockcode) { return -1; }
                    if (a.product.stockcode > b.product.stockcode) { return 1; }
                    return 0;
                });
                break;
            case 'productcodeDesc':
                formLines.sort((a, b) => {
                    if (a.product.stockcode > b.product.stockcode) { return -1; }
                    if (a.product.stockcode < b.product.stockcode) { return 1; }
                    return 0;
                });
                break;
            case 'priceAsc':
                formLines.sort((a, b) => {
                    return b.product.bestPrice - a.product.bestPrice;
                });
                break;
            case 'priceDesc':
                formLines.sort((a, b) => {
                    return a.product.bestPrice - b.product.bestPrice;
                });
                break;
            case 'nameAsc':
                formLines.sort((a, b) => {
                    if (a.product.name < b.product.name) { return -1; }
                    if (a.product.name > b.product.name) { return 1; }
                    return 0;
                });
                break;
            case 'nameDesc':
                formLines.sort((a, b) => {
                    if (a.product.name > b.product.name) { return -1; }
                    if (a.product.name < b.product.name) { return 1; }
                    return 0;
                });
                break;
        }

        return formLines;
    }     

    render() {
        var self = this;       

        return (
            <div className="template template-edit">

                <ReactModal isOpen={this.state.copyTemplateModalOpen} onRequestClose={this.closeCopyTemplateModal.bind(this)} portalClassName="modal-portal modal-portal-permission" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h3 className="m-0">Copy Template</h3>
                        </div>
                        <div className="modal-body">
                            <Form
                                defaultValues={this.state.copyTemplateValues}
                                onChange={this.setCopyTemplateChange.bind(this)}
                                onSubmit={this.submitCopyTemplate.bind(this)}>
                                {formApi => (
                                    <form onSubmit={formApi.submitForm} id="dynamic-form">
                                        <div className="row">
                                            <div className="col-12 custom-control">
                                                <label htmlFor="dynamic-template-name">Template Name</label>
                                                <Text field="templateName" id="dynamic-template-name" className="form-control" onInput={(e) => this.validateLength(e, 50)} /> <br />
                                            </div>
                                            <div className="col-12 custom-control custom-checkbox my-1 mr-sm-2">
                                                <Checkbox field="copyPermission" id="copy-permission" className="custom-control-input" />
                                                <label className="custom-control-label ml-4" htmlFor="copy-permission">Copy Permission</label>
                                            </div>
                                        </div>
                                        {this.renderSubmitCopyTemplateButton()}
                                    </form>
                                )}
                            </Form>
                        </div>
                        <button onClick={this.closeCopyTemplateModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </ReactModal>

                <ReactModal isOpen={this.state.scheduleModalOpen} onRequestClose={this.closeScheduleModal.bind(this)} portalClassName="modal-portal" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h5 className="m-0">Schedule</h5>
                        </div>
                        <div className="modal-body">
                            <ScheduleSelector />
                            <div>
                                <button className="float-right btn btn-primary" onClick={this.createSchedule.bind(this) }>Create Schedule</button>
                            </div>
                        </div>
                        <button onClick={this.closeScheduleModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </ReactModal>

                <ReactModal isOpen={this.state.permissionsModalOpen} onRequestClose={this.closePermissionsModal.bind(this)} portalClassName="modal-portal modal-portal-permission" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h3 className="m-0">Share</h3>
                        </div>
                        <div className="modal-body">
                            <Form
                                defaultValues={this.state.permissions}
                                
                                onChange={this.setGroupChange.bind(this)}
                                onSubmit={this.submitGroupPermissions.bind(this)}>
                                {formApi => (
                                    <form onSubmit={formApi.submitForm} id="dynamic-form">
                                        <h5>View Permissions</h5>
                                        <GroupSelector field="view" />

                                        <h5>Edit Permissions</h5>
                                        <GroupSelector field="edit" />

                                        {this.renderGroupSaveButton()}
                                    </form>
                                )}
                            </Form>
                        </div>
                        <button onClick={this.closePermissionsModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </ReactModal>

                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitTemplate.bind(this)} defaultValues={this.props.initialTemplate}>
                    {formApi => {
                        self.formApi = formApi; 
                        var isCompactView = this.state.isCompactView;
                        var extraHeaderClass = "";
                        if (isCompactView) {
                            extraHeaderClass += " list-compact";
                        }

                        return (
                            <div>
                                <form onSubmit={formApi.submitForm} id="dynamic-form">
                                    <div className="card card-body bg-light">
                                        <label htmlFor="dynamic-template-name">Template Name:</label>
                                        <Text field="name" id="dynamic-template-name" className="form-control" onInput={(e) => this.validateLength(e, 50)}/> <br/>
                                        <div className="row">
                                            <div className="col-12">
                                                <label htmlFor="linked-site">Linked Site:</label>
                                            </div>
                                            <div className="col-12 col-lg-8">
                                                <SiteSelector field="linkedSite" id="linked-site"/>
                                            </div>
                                        </div>
                                        <div>
                                            {this.renderShareButton()}

                                            
                                            { /* <button className="btn btn-primary float-right" onClick={this.openScheduleModal.bind(self)}>Schedule</button>*/
                                            }

                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <h5>
                                                Add item to template
                                            </h5>
                                        </div>

                                        <div className="col-12 col-lg-7">
                                            <div className="row">
                                                <div className="col-9">
                                                    <ProductSelector field="productSearch" onKeyDown={self.addNewLineKeyPress.bind(self, formApi)} />
                                                </div>
                                                <div className="col-3">
                                                    <button
                                                        onClick={self.addNewLine.bind(self, formApi)}
                                                        type="button"
                                                        className="mb-4 mr-4 btn btn-success">Add</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-5">
                                            {this.renderUpperButtons()}
                                        </div>
                                    </div>
                                    <div className={"list-group" + extraHeaderClass}> 
                                        {self.renderTableHeader(formApi.values.lines, isCompactView)}

                                        {formApi.values.lines &&
                                            this.getSortedLines(formApi.values.lines).map((line, i) => (
                                                <NestedField field={['lines', i]} key={"template-lines-" + i}>
                                                <TemplateEditLine
                                                    templateLine={line}
                                                    removeItemClick={this.removeLine.bind(self, line)}
                                                    updateQuantityChange={this.updateQuantity.bind(self, line)}
                                                    onChange={this.setChange.bind(this)}
                                                    isCompactView={isCompactView}
                                                    />
                                                </NestedField>
                                            ))}
                                    </div>
                                    {this.renderSaveButton()}

                                    {this.renderCopyTemplateButton()}
                                </form>

                            </div>
                        );
                    }}
                </Form>

                {this.renderFinishEditingButton()}
            </div>
        );
    }
}